import React, { useEffect, useState } from "react";
import styles from "../../../assets/css/admin/layout.module.css";
import "../../../assets/css/admin/allAdmins.module.css";
import SideBar from "../SideBar";
import axios from "axios";
import { baseUrl } from "../../../baseUrl";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import {useAuth} from "../../../AuthContext"
import { useSidebar } from "../../../context/SidebarContext";
import MenuIcon from '@mui/icons-material/Menu';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';
import EditIcon from '@mui/icons-material/Edit';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import CloneQuestionsModal from "../exam/modal/CloneQuestionsModal";
import { toast } from "react-toastify";
import CopyQuestionsModal from "../exam/modal/CopyQuestionsModal";
import api from "../../../api";

const AllQuestionsExamwise = () => {
  const { logout, user } = useAuth();
  const { isSidebarOpen, toggleSidebar } = useSidebar();
  const [allQuestions, setAllQuestions] = useState([]);
  const [questionsLoading,setQuestionsLoading] = useState(false);
  const [courses, setCourses] = useState([]);
  const [exams,setExams]=useState([])
  const [filteredQuestions, setFilteredQuestions] = useState([]);
  const [classFilter, setClassFilter] = useState(localStorage.getItem('all-questions-class') || '');
  const [courseFilter, setCourseFilter] = useState(localStorage.getItem('all-questions-course') || '');
  const [examFilter, setExamFilter] = useState(localStorage.getItem('all-questions-exam') || '');
  const [subjectFilter, setSubjectFilter] = useState(localStorage.getItem('all-questions-subject') || '');
  const [searchFilter, setSearchFilter] = useState(localStorage.getItem('all-questions-search') || '');
  const [searchInput, setSearchInput] = useState(localStorage.getItem('all-questions-search') || '');
  const [selectedQuestions,setSelectedQuestions]=useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isModalOpen2, setIsModalOpen2] = useState(false);
  const openModal = () => {
    if(selectedQuestions.length<1){
      toast.error('Please select at least one question to Clone');
      return;
    }
    setIsModalOpen(true);
  };

  const closeModal = () => {
    setIsModalOpen(false);
  };
  const openModal2 = () => {
    if(selectedQuestions.length<1){
      toast.error('Please select at least one question to Copy');
      return;
    }
    setIsModalOpen2(true);
  };

  const closeModal2 = () => {
    setIsModalOpen2(false);
  };

  const contentRef = React.useRef();

  const handleClassFilter = (e) => {
    localStorage.setItem("all-questions-class",e.target.value)
    setClassFilter(e.target.value)
  }

  
  const handleCourseFilter = (e) => {
    const selectedCourseID = e.target.value;
    localStorage.setItem("all-questions-course", selectedCourseID);
    setCourseFilter(selectedCourseID);
  };
  
  const handleExamFilter = (e) => {
    const selectedExamID = e.target.value;
    localStorage.setItem("all-questions-exam", selectedExamID);
    setExamFilter(selectedExamID);
  };
  
  const handleSubjectFilter = (e) => {
    const selectedSubject = e.target.value;
    localStorage.setItem("all-questions-subject", selectedSubject);
    setSubjectFilter(selectedSubject);
  };

  const handleSearchFilter = (e) => {
    e.preventDefault();
    const search = searchInput.trim();
    localStorage.setItem("all-questions-search", search);
    setSearchFilter(search);
  };

  const clearSearchFilter = () => {
    localStorage.removeItem("all-questions-search");
    setSearchInput("");
    setSearchFilter("");
  };

  const getSearchableText = (question) => {
    const parser = new DOMParser();
    const fields = [
      question.question,
      ...(question.options || []),
      question.correct,
      question.solution,
      question.subject,
      question.class,
    ];

    return fields
      .filter(Boolean)
      .map((value) => parser.parseFromString(String(value), "text/html").body.textContent || "")
      .join(" ")
      .toLowerCase();
  };
  
  const getQuestions = () => {
    setQuestionsLoading(true);
    axios
      .get(`${baseUrl}/exam/question-paper?examId=${examFilter}`)
      .then((res) => {
        const questions = res.data.questionPaper;

        const subjectOrder = ["Physics", "Chemistry", "Biology"];

        const sortedQuestions = questions.sort(
          (a, b) => subjectOrder.indexOf(a.subject) - subjectOrder.indexOf(b.subject)
        );

        setAllQuestions(sortedQuestions);
        setQuestionsLoading(false);
      })
      .catch((e) => {
        console.log(e);
        setQuestionsLoading(false);
      });
  };

  const getCourses = () => {
    axios.get(`${baseUrl}/course/by-class?className=${classFilter}`)
      .then(res => setCourses(res.data))
      .catch(err => console.log(err))
  }
  const getExams = () => {
    axios.get(`${baseUrl}/exam/course/${courseFilter}`)
      .then(res => setExams(res.data.exams))
      .catch(err => console.log(err))
  }


    const filterQuestions = () => {
      let filtered = [...allQuestions]; // Start with all exams
      if (subjectFilter) {
        filtered = filtered.filter((question) => question.subject === subjectFilter); // Apply class filter
      }
      if (searchFilter.trim()) {
        const search = searchFilter.trim().toLowerCase();
        filtered = filtered.filter((question) => getSearchableText(question).includes(search));
      }
      setFilteredQuestions(filtered); // Update filtered exams based on the applied filters
    };
    useEffect(() => {
      setAllQuestions([])
      getQuestions();
    },[examFilter])
    useEffect(()=>{
      setCourses([])
      setAllQuestions([])
      setExams([])
      getCourses();
    },[classFilter])
    useEffect(()=>{
      setExams([])
      getExams();
    },[courseFilter])
  useEffect(() => {
    filterQuestions(); // Apply filters whenever any filter value changes
  }, [subjectFilter, searchFilter, allQuestions]);
  const deleteQuestion = (a) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover!",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        api.post(`${baseUrl}/question/delete/?id=${a.id}`).then((res) => {
          getQuestions();
          swal(res.data.message, {
            icon: "success",
          });
        }).catch(err=>{
          swal(err?.response?.data?.message || "Something went wrong",{
            icon:"error"
          })
        })
      }
    });
  };

  const handleCheck = (id) => {
    setSelectedQuestions((prevSelected) =>
      prevSelected.includes(id)
        ? prevSelected.filter((questionId) => questionId !== id)
        : [...prevSelected, id]
    );
  };  

  return (
    <div className={`${styles.layout} ${isSidebarOpen ? '' : `${styles.sidebarClosed}`}`}>
      <aside className={`${styles.sidebar} ${isSidebarOpen ? `${styles.open}` : `${styles.closed}`}`}>
        <SideBar />
      </aside>

      <main className={styles.mainContent}>
      <CloneQuestionsModal isOpen={isModalOpen} closeModal={closeModal} questionIds={selectedQuestions} />
      <CopyQuestionsModal isOpen={isModalOpen2} closeModal={closeModal2} questionIds={selectedQuestions} />
      <div style={{ height: '30px' }} className="position-relative">{isSidebarOpen ? <CloseIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} /> : <MenuIcon className={`position-absolute end-0 ${styles.ham}`} onClick={toggleSidebar} />}</div>
        <nav aria-label="breadcrumb" >
          <ol className="breadcrumb">
            <div className="d-flex flex-grow-1">
              <li className="breadcrumb-item">
                <Link to='/admin/dashboard' className="text-decoration-none">Dashboard</Link>
              </li>
              <li className="breadcrumb-item active">
                Questions
              </li>
              <li className="breadcrumb-item">
                <Link to='/admin/question/add' className="text-decoration-none">Add</Link>
              </li>
            </div>
            <li className="nav-item dropdown">
              <span
                className="nav-link dropdown-toggle"
                data-bs-toggle="dropdown"
                href=""
                role="button"
                aria-expanded="false"
              >
                Welcome, {user.name}
                <i className="ml-2 fa fa-angle-down"></i>
              </span>
              <ul className="dropdown-menu" style={{ minWidth: '150px' }}>
                <li>
                  <span className="dropdown-item" onClick={logout}>
                    Logout
                  </span>
                </li>
              </ul>
            </li>
          </ol>
        </nav>
        <div
          className="container-fluid"
          style={{ backgroundColor: "white", padding: "20px" }}
        >
          <div className="d-flex justify-content-between align-items-center mb-4">
            <h4>Questions</h4>
            <div>
              <span className="me-2 fs-6">Selected Questions : {selectedQuestions.length}</span>
              <button onClick={openModal} className="btn btn-sm btn-info mr-2">Clone</button>
              <button onClick={openModal2} className="btn btn-sm btn-success">Copy</button>
            </div>
          </div>
          
          <div className="filters mb-4 d-flex flex-wrap gap-3">
            <div className="filter-item">
              <label htmlFor="classFilter" className="form-label">Class</label>
              <select
                id="classFilter"
                className="form-select"
                value={classFilter}
                onChange={handleClassFilter}
              >
                <option value="">Select Class</option>
                <option value="Class XI">Class XI</option>
                <option value="Class XII">Class XII</option>
                <option value="Class XII Passed">Class XII Passed</option>
              </select>
            </div>
            <div className="filter-item">
              <label htmlFor="courseFilter" className="form-label">Course</label>
              <select
                id="courseFilter"
                className="form-select"
                value={courseFilter}
                onChange={handleCourseFilter}
              >
                <option value="" hidden>Select Course</option>
                {
                  courses.map((c,i)=>
                  <option key={i} value={c.courseID}>{`${c.className} - ${c.title}`}</option>)
                }
              </select>
            </div>
            <div className="filter-item">
              <label htmlFor="examFilter" className="form-label">Exam</label>
              <select
                id="examFilter"
                className="form-select"
                value={examFilter}
                onChange={handleExamFilter}
              >
                <option value="" hidden>Select exam</option>
                {
                  exams.map((exam, i) =>
                    <option key={i} value={exam._id}>{exam.examName}</option>)
                }
              </select>
            </div>
            <div className="filter-item">
              <label htmlFor="subjectFilter" className="form-label">Subject</label>
              <select
                id="subjectFilter"
                className="form-select"
                value={subjectFilter}
                onChange={handleSubjectFilter}
              >
                <option value="">All</option>
                <option value="Physics">Physics</option>
                <option value="Chemistry">Chemistry</option>
                <option value="Biology">Biology</option>
              </select>
            </div>
            <div className="filter-item">
              <label htmlFor="searchFilter" className="form-label">Search Question</label>
              <form className="d-flex gap-2" onSubmit={handleSearchFilter}>
                <input
                  id="searchFilter"
                  className="form-control"
                  type="search"
                  placeholder="Question, option, answer..."
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                />
                <button className="btn btn-primary" type="submit">
                  Search
                </button>
                {searchFilter && (
                  <button className="btn btn-outline-secondary" type="button" onClick={clearSearchFilter}>
                    Clear
                  </button>
                )}
              </form>
            </div>
          </div>
          {
            examFilter === "" ? "Please select exam" :
              <>
          <p>Found {filteredQuestions.length} questions with selected filter</p>
          <div ref={contentRef} style={{overflowX:'scroll'}}>
            <table>
              <thead>
                <tr>
                  <td>SI</td>
                  <td></td>
                  <td>Is Clone?</td>
                  <td>Question</td>
                  <td>Options</td>
                  <td>Correct</td>
                  <td>Actions</td>
                </tr>
              </thead>
              <tbody>
                {
                  questionsLoading&&<><br/><img src="/assets/images/load-time.gif" width='50px' alt="loading"/></>
                }
                {filteredQuestions.length > 0 &&
                  filteredQuestions.map((a, i) => (
                    <tr key={i}>
                      <td>{i + 1}</td>
                      <td>
                        <input type="checkbox"
                          checked={selectedQuestions.includes(a.id)}
                          onChange={() => handleCheck(a.id)} />
                      </td>
                      <td>{a.isClone?'Clone':'Not Clone'}</td>
                      <td>
                        <div className="mt-4">
                          <div
                            className="question-preview"
                            dangerouslySetInnerHTML={{
                              __html: a.question,
                            }}
                          />
                        </div>
                      </td>
                      <td>
                        {
                          a.options.map((o, j) =>
                            <span key={j} className="p-2 d-flex" style={{ minWidth: '170px' }}
                              dangerouslySetInnerHTML={{
                                __html: `(${j + 1})&nbsp${o}`,
                              }}></span>
                          )
                        }
                      </td>
                      <td>{a.correct}</td>
                      <td>
                        <Link to={`/admin/question/edit/${a.id}`}>
                          <button className="btn btn-success btn-sm p-1 m-1"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top" // Tooltip position
                            title="Edit Question">
                            <EditIcon fontSize="small" />
                          </button>
                        </Link>
                        &nbsp;
                        <Link to={`/admin/question/view/${a.id}`}>
                          <button className="btn btn-info btn-sm p-1 m-1"
                            data-bs-toggle="tooltip"
                            data-bs-placement="top" // Tooltip position
                            title="View Question"><VisibilityIcon fontSize="small" /></button>
                        </Link>
                        &nbsp;
                        <button
                          onClick={() => deleteQuestion(a)}
                          className="btn btn-danger btn-sm p-1 m-1"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top" // Tooltip position
                          title="Delete Question"
                        >
                          <DeleteOutlineIcon fontSize="small"/>
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
              </>
          }
        </div>
      </main>
    </div>
  );
};

export default AllQuestionsExamwise;
